import React from 'react'

const CampaignListingBoxSkeleton = () => {
    return (
        <div className='border border-neutral-100 rounded-card py-5 2xl:px-6 px-5 flex md:items-center justify-between max-md:flex-col max-md:gap-5 bg-white shadow-soft'>
            <div className='flex flex-col gap-3'>
                {/* Date skeleton */}
                <div className="flex items-center gap-2">
                    <div className='w-4 h-4 rounded bg-neutral-200 animate-pulse' />
                    <div className='rounded-lg bg-neutral-200 animate-pulse w-52 h-4' />
                </div>
                {/* Avatar + name skeleton */}
                <div className='flex items-center gap-3'>
                    <div className='min-w-11 w-11 h-11 rounded-full bg-neutral-200 animate-pulse' />
                    <div className='flex flex-col gap-1.5'>
                        <div className='rounded-lg bg-neutral-200 animate-pulse w-40 h-5' />
                        <div className='rounded-lg bg-neutral-200 animate-pulse w-24 h-4' />
                    </div>
                </div>
            </div>
            {/* Stats skeleton */}
            <div className='flex items-center gap-3 max-md:justify-start'>
                <div className='rounded-xl bg-neutral-100 animate-pulse w-[72px] h-[52px]' />
                <div className='rounded-xl bg-neutral-100 animate-pulse w-[72px] h-[52px]' />
            </div>
        </div>
    )
}

export default CampaignListingBoxSkeleton
